import { z } from "zod";
import { organizationDtoSchema } from "./organization.js";

export const membershipRoleSchema = z.enum(["owner", "admin", "agent", "viewer"]);
export type MembershipRole = z.infer<typeof membershipRoleSchema>;

/**
 * Carries the organization inline rather than a bare `orgId` — the org
 * switcher needs a name and slug to render, not a second round trip.
 */
export const membershipDtoSchema = z.object({
  organization: organizationDtoSchema,
  role: membershipRoleSchema,
  createdAt: z.string().datetime(),
});

export type MembershipDto = z.infer<typeof membershipDtoSchema>;
